import application_settings from '../applicationSettings';
import Event from './Event';

class GetFavoriteList extends Event {
    eventName = 'oms_getFavoriteList';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get order history
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        // request data
        data.endPoint = application_settings.endPoints.getFavoriteList;
        data.canUsePublicAuth = false;
        data.data = {
            location_id: data?.location_id,
            product_id: data?.product_id,
            start: data.start,
            limit: data.limit,
            keyword: data?.keyword,
            order_currency: data?.order_currency
        };-

        this.sendRequest(data, function (response) {
            if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });
    }
}

export default GetFavoriteList;